import isEmptyExt from '@utils/chekers/isEmptyExt';

/**
 * Удаляет пустые значения опираясь на метод isEmptyExt
 * @param {Record<string, unknown>} pure_params
 * @returns {Record<string, unknown>}
 */
const removeEmptyParams = (pure_params: Record<string, unknown>): Record<string, unknown> => {
    return Object.entries(pure_params).reduce((obj, [key, value]) => {
        if (isEmptyExt(value)) return obj;

        return {
            ...obj,
            [key]: value,
        };
    }, {});
};

export default removeEmptyParams;
